import { useRef } from 'react';
import cm from 'classnames';

import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { useLocation, Path } from 'components/_hooks/use-router';
import { useClipsDelete } from 'components/app/editor/_mediator/editor-clips/use-clips-delete';
import { Clip, setConfigPanel } from 'components/app/editor/_mediator/editor.slice';

import { ConfigIco } from 'components/app/editor/editor-configure/config-ico';
import { ClipLabels } from 'components/app/app-components/clip-labels/clip-labels';
import styles from './_track-clip.module.scss';

interface Props {
  clipData: Clip;
  className?: string;
}

export const ClipUi = ({ clipData, className }: Props) => {
  const { configPanel, activeClip } = useAppSelector((state) => state.editor);
  const { path } = useLocation();
  const dispatch = useAppDispatch();
  const deleteClip = useClipsDelete();

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} className={cm(styles.UI, { [styles['UI--linked']]: clipData.clipGroupId }, className)}>
      {path !== Path.finalcuts && !clipData.isAutoHighlight && (
        <button
          className={styles.UI__deleteButton}
          onClick={(e) => {
            e.stopPropagation();
            deleteClip(clipData.clipId);
          }}
        >
          ✕
        </button>
      )}
      <ClipLabels containerRef={containerRef} clipData={clipData} />
      {(path === Path.selector || path === Path.storyboard) && activeClip === clipData.clipId && (
        <ConfigIco
          className={styles.UI__configIco}
          onClick={() => dispatch(setConfigPanel(configPanel !== 'clip' ? 'clip' : null))}
        />
      )}
    </div>
  );
};
